export class TargetFinancialStatement {
    constructor(obj) {
        this.AccountingStandardType = obj.AccountingStandardType;
        this.ConsolidationType = obj.ConsolidationType;
        this.FinancialStatementType = obj.FinancialStatementType;
    }
}